import script from "./mixmatch-product.vue?vue&type=script&setup=true&lang=js"
export * from "./mixmatch-product.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__